import React from 'react';
import { Href } from '../../components';
import { TERMS_OF_SERVICE_TEXT } from '../../constants';
export var TermsOfServiceComponent = function (_a) {
    var url = _a.url;
    return (React.createElement("div", null,
        React.createElement(Href, { href: url },
            React.createElement("span", null, TERMS_OF_SERVICE_TEXT))));
};
//# sourceMappingURL=TermsOfService.js.map